export default __webpack_public_path__ + "static/media/ad_468x60_install_en@2x.8455cad2.png";